import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaInfoCircle, FaBox, FaEye, FaHandHoldingHeart, FaEnvelope } from 'react-icons/fa';
import { useData } from '../../context/DataContext';
import '../../styles/components/Header.css';

const Header = () => {
  const location = useLocation();
  const { data, getUIText } = useData();
  const globalUI = getUIText('global');

  // Use navLinks from JSON or fallback to defaults
  const navLinks = globalUI?.navLinks || [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/products', label: 'Products' },
    { path: '/services', label: 'Services' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  // Get icon for each nav link
  const getNavIcon = (path) => {
    switch (path) {
      case '/':
        return <FaHome />;
      case '/about':
        return <FaInfoCircle />;
      case '/products':
        return <FaBox />;
      case '/vision':
        return <FaEye />;
      case '/services':
        return <FaHandHoldingHeart />;
      case '/contact':
        return <FaEnvelope />;
      default:
        return <FaHome />;
    }
  };

  return (
    <>
      <header className="header">
        <div className="header-top">
          <div className="container">
            <Link to="/" className="logo">
              <img
                src={data?.images?.logo}
                alt={data?.name}
                className="logo-image"
              />
              <div className="logo-text">
                <span className="logo-name">{data?.name}</span>
              </div>
            </Link>

            <div className="header-actions">
              <Link to="/contact" className="login-btn">
                {globalUI?.contactButton || 'Contact Us'}
              </Link>
            </div>
          </div>
        </div>

        <nav className="nav-menu">
          <div className="container">
            <ul className="nav-list">
              {navLinks.map((link) => (
                <li key={link.path} className="nav-item">
                  <Link
                    to={link.path}
                    className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </header>

      {/* Mobile Bottom Navigation */}
      <nav className="mobile-bottom-nav">
        <ul className="bottom-nav-list">
          {navLinks.map((link) => (
            <li key={link.path} className="bottom-nav-item">
              <Link
                to={link.path}
                className={`bottom-nav-link ${isActive(link.path) ? 'active' : ''}`}
              >
                <span className="bottom-nav-icon">{getNavIcon(link.path)}</span>
                <span className="bottom-nav-label">{link.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default Header;
